































import { Vue, Component, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import MeUpdate from 'src/graphql/person/MeUpdate.gql'
import api from 'src/assets/api/gql'

@Component
export default class AccountNameChange extends Vue {
  person = store.state.person
  name = ''
  loading: boolean = false
  error: boolean = false

  get isNewNameValid(): boolean {
    return this.name.length > 0 && this.name !== this.person.name
  }

  created () {
    this.name = this.person.name
  }

  async save () {
    if (this.isNewNameValid) {
      this.loading = true
      const { data: { updatePerson } } = await api.mutate({
        query: MeUpdate,
        variables: { id: this.person.id, data: { name: this.name } }
      })
      this.loading = false
      if (updatePerson && updatePerson.person) {
        store.setPerson(updatePerson.person)
      }
    }
  }
}
